var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cs",style:(_vm.containerStyle)},[_c('div',{staticClass:"cs__image",style:(_vm.imageStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }